import React from 'react';
import { SIGN_BY_TYPE_OF_TRANSACTION } from '../../transactions';
import { TransactionHelper } from '../../transactions/helper/transactions.helper';
import { Typography } from 'antd';

const AuthorizationAmountView = ({ authorization }) => {
  if (!authorization || !authorization.info) return null;

  const { approved, irc, info } = authorization;
  const sign = approved || irc === '8444'
    ? SIGN_BY_TYPE_OF_TRANSACTION.get(info.transaction.type)
    : '';

  const formattedAmount = TransactionHelper.getTransactionAmountFormatted(
    info.amounts.original.currency,
    info.amounts.original.amount
  );

  return (
    <Typography.Text  strong style={{color: approved ? '#52c41a' : '#ff4d4f', margin: '5px'}}>
      {sign}{formattedAmount}
    </Typography.Text>
  );
};

export default AuthorizationAmountView;
